import { HttpClient, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Params } from "@angular/router";
import { Observable } from "rxjs";
import { APIUrl } from "src/app/features-common/constants/APIUrls";
import { BaseService } from "src/app/framework/services/base.service";

@Injectable()
export class ProvidersService extends BaseService {
  constructor() {
    super();
  }

  getConfigValues() {
    let params = new HttpParams().set("config_name", "BusinessType");
    // return this.http.get(APIUrl.congifValues, { params });
    return this.httpService.getRetailerData(APIUrl.congifValues, params);
  }

  // Get all provider details
  //GET:/api/v1/admin/providers/

  getallproviders() {
    return this.httpService.get(APIUrl.allProviders);
  }

  // Add new provider
  addNewProvider(params) {
    //let url = APIUrl.provider + `/` + APIUrl.save;
    return this.httpService.post(APIUrl.allProviders, params);
  }

  getAllActivePricelists() {
    return this.httpService.get(APIUrl.pricelists);
  }

  getretailerPricelists() {
    return this.httpService.get(APIUrl.retailerpricelists);
  }
  getconsumerpricelists() {
    return this.httpService.get(APIUrl.consumerpricelists);
  }
  
  getsalesrepsPricelists() {
    return this.httpService.get(APIUrl.salesrepspricelists);
  }


  getAllPricelistsForGrid():Observable<any>{
    return this.httpService.get(APIUrl.gridPricelist);
  }

  updateProductPricelist(formData):Observable<any>{
    return this.httpService.put(APIUrl.updateProdutPricelist, formData)
  }



  getmappedPricelists(salesrep) {
    let url = `${APIUrl.salesrepspricelists}/${salesrep}`;
    return this.httpService.get(url);
  }
  updatemappedPricelists(salesrep,pricelist) {
    let params = {
      "priceListName": salesrep,
      "retailerPriceList": pricelist,
      
    }
    let url = `${APIUrl.salesrepspricelists}/${salesrep}`;
    return this.httpService.postParams(url,params);
  }

  // Get all products for selected pricelist
  getAllproductsforPricelist(priceList) {
    let id = "1";
    let params = new HttpParams().set("priceListName", priceList);
    //.set('ProductId', id)
    let url = APIUrl.pricelistName;
    return this.httpService.getParams(url, params);
  }

  // Get all Product types
  getallproducttypes() {
    let params = new HttpParams().set("config_name", "ProductType");
    return this.httpService.getRetailerData(APIUrl.congifValues, params);
  }

  // Get all CodeGroup
  getallcodegroup() {
    let params = new HttpParams().set("config_name", "InvoiceGrouping");
    return this.httpService.getRetailerData(APIUrl.congifValues, params);
  }

  getCarriers() {
    return this.httpService.get(APIUrl.carriers);
  }

  // bulkpricelistupdate
  bulkpricelistupdate(params) {
    let url = APIUrl.bulkpricelists;
    return this.httpService.put(url, params);
  }

  // Get all products for selected pricelist
  getcreatePricelist(params) {
    let url = APIUrl.pricelists;
    return this.httpService.postParams(url, params);
  }

  updateProduct(params) {
    return this.httpService.put(APIUrl.products, params);
  }
  updateProvider(params) {
    return this.httpService.put(APIUrl.allProviders, params);
  }
  getProvider(providerId) {
    return this.httpService.get(APIUrl.allProviders + providerId);
  }

  getProductDetails(productId) {
    let url = `${APIUrl.products}/${productId}`;
    return this.httpService.get(url);
  }

  // Get all plan types
  getallplantypes() {
    let params = new HttpParams().set("config_name", "PlanType");
    return this.httpService.getRetailerData(APIUrl.congifValues, params);
  }
  // Get all ProviderService
  getallProviderService() {
    let params = new HttpParams().set("config_name", "ProviderService");
    return this.httpService.getRetailerData(APIUrl.congifValues, params);
  }
  // Get all Response Types
  getallresponseTypes() {
    let params = new HttpParams().set("config_name", "ResponseType");
    return this.httpService.getRetailerData(APIUrl.congifValues, params);
  }

  //TransactionTypes
  getTransactionTypes() {
    let params = new HttpParams().set("config_name", "TransactionType");
    return this.httpService.getRetailerData(APIUrl.congifValues, params);
  }
  //codeGroup
  getcodeGroups() {
    let params = new HttpParams().set("config_name", "InvoiceGrouping");
    return this.httpService.getRetailerData(APIUrl.congifValues, params);
  }
  getserviceCountry() {
    return this.httpService.get(APIUrl.country);
  }
  // Get all provider details
  getactiveproviders() {
    return this.httpService.get(APIUrl.activeProviders);
  }
  // Import excel
  import(file) {
    return this.httpService.get(APIUrl.import);
  }
  postFile(fileToUpload: File, providerid) {
    //const endpoint = this.httpService.get(APIUrl.import)
    const formData: FormData = new FormData();
    formData.append("priceListFile", fileToUpload, fileToUpload.name);
    formData.append("providerId", providerid);
    return this.httpService.post(APIUrl.import, formData);
  }
}
